export const serviceCatalog = [
  {
    id: 1,
    slug: 'tokenizacion-activos-rwa',
    cName: 'fas fa-coins',
    title: { es: 'Tokenización de activos (RWA)', en: 'Asset tokenization (RWA)' },
    desc: {
      es: 'Estructuramos proyectos para representar activos reales mediante modelos digitales verificables, con trazabilidad, gobernanza y diseño operativo.',
      en: 'We structure projects to represent real-world assets through verifiable digital models with traceability, governance and operational design.'
    },
    heroTitle: { es: 'Tokenización de activos con visión empresarial', en: 'Enterprise-ready asset tokenization' },
    heroText: {
      es: 'Diseñamos marcos de tokenización para agricultura, real estate, infraestructura, propiedad intelectual y otras categorías con potencial de digitalización.',
      en: 'We design tokenization frameworks for agriculture, real estate, infrastructure, intellectual property and other categories with strong digitalization potential.'
    },
    bullets: {
      es: [
        'Definición del activo, derechos, flujos y trazabilidad.',
        'Arquitectura documental, operativa y tecnológica.',
        'Experiencia de usuario clara para consulta, validación y operación.'
      ],
      en: [
        'Definition of the asset, rights, cash flows and traceability.',
        'Document, operational and technical architecture.',
        'Clear user experience for verification, validation and operations.'
      ]
    },
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80',
    email: 'rwa@innovativehorizonseua.com',
    contactName: 'RWA team'
  },
  {
    id: 2,
    slug: 'tokenizacion-academica',
    cName: 'fas fa-user-graduate',
    title: { es: 'Tokenización académica', en: 'Academic tokenization' },
    desc: {
      es: 'Transformamos certificados, constancias, microcredenciales y trayectorias formativas en credenciales digitales con consulta verificable.',
      en: 'We transform certificates, micro-credentials and learning paths into digital credentials with verifiable access.'
    },
    heroTitle: { es: 'Credenciales digitales para instituciones modernas', en: 'Digital credentials for modern institutions' },
    heroText: {
      es: 'Integramos validación académica, trazabilidad documental e identidad verificable para universidades, academias y ecosistemas educativos.',
      en: 'We integrate academic validation, document traceability and verifiable identity for universities, academies and education ecosystems.'
    },
    bullets: {
      es: [
        'Títulos, diplomas y constancias verificables.',
        'Microcredenciales y rutas formativas modulares.',
        'Consulta pública o privada con control institucional.'
      ],
      en: [
        'Verifiable degrees, diplomas and certificates.',
        'Micro-credentials and modular learning pathways.',
        'Public or private verification with institutional control.'
      ]
    },
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1400&q=80',
    email: 'academica@innovativehorizonseua.com',
    contactName: 'Academic solutions team'
  },
  {
    id: 3,
    slug: 'pasaporte-del-conocimiento',
    cName: 'fas fa-id-card',
    title: { es: 'Pasaporte del Conocimiento', en: 'Knowledge Passport' },
    desc: {
      es: 'Construimos sistemas de identidad formativa para reunir logros, evidencias y competencias en una sola experiencia digital.',
      en: 'We build learning identity systems that bring achievements, evidence and competencies into one elegant digital experience.'
    },
    heroTitle: { es: 'Identidad académica portable y verificable', en: 'Portable and verifiable academic identity' },
    heroText: {
      es: 'El Pasaporte del Conocimiento permite a personas e instituciones organizar trayectorias, certificaciones y evidencia de aprendizaje.',
      en: 'The Knowledge Passport allows people and institutions to organize learning paths, credentials and evidence of achievement.'
    },
    bullets: {
      es: [
        'Historial verificable de aprendizaje.',
        'Portabilidad de credenciales y competencias.',
        'Base para empleabilidad, movilidad y reputación digital.'
      ],
      en: [
        'Verifiable learning history.',
        'Portability of credentials and competencies.',
        'Foundation for employability, mobility and digital reputation.'
      ]
    },
    image: 'https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&w=1400&q=80',
    email: 'pasaporte@innovativehorizonseua.com',
    contactName: 'Knowledge Passport team'
  },
  {
    id: 4,
    slug: 'desarrollo-dapps',
    cName: 'fas fa-laptop-code',
    title: { es: 'Desarrollo de dApps', en: 'dApp development' },
    desc: {
      es: 'Creamos aplicaciones descentralizadas con paneles, validaciones, wallets, formularios y experiencias de producto adaptadas al proyecto.',
      en: 'We build decentralized applications with dashboards, validations, wallets, forms and product experiences tailored to the project.'
    },
    heroTitle: { es: 'Producto digital con experiencia elegante', en: 'Elegant digital product design' },
    heroText: {
      es: 'Diseñamos interfaces y arquitectura funcional para productos Web3, plataformas híbridas y módulos con interacción blockchain.',
      en: 'We design interfaces and functional architecture for Web3 products, hybrid platforms and blockchain-enabled modules.'
    },
    bullets: {
      es: [
        'Dashboards y módulos administrativos.',
        'Conexión con wallets y validaciones.',
        'UX clara para usuarios no técnicos y técnicos.'
      ],
      en: [
        'Dashboards and admin modules.',
        'Wallet connection and validation flows.',
        'Clear UX for technical and non-technical users.'
      ]
    },
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1400&q=80',
    email: 'dapps@innovativehorizonseua.com',
    contactName: 'dApp development team'
  },
  {
    id: 5,
    slug: 'smart-contracts-para-blockchain',
    cName: 'fas fa-file-contract',
    title: { es: 'Smart contracts para blockchain', en: 'Smart contracts for blockchain' },
    desc: {
      es: 'Diseñamos lógica on-chain para emisión de tokens, automatización, control de roles y ejecución programable con foco en claridad funcional.',
      en: 'We design on-chain logic for token issuance, automation, role control and programmable execution with a focus on functional clarity.'
    },
    heroTitle: { es: 'Infraestructura legal y técnica programable', en: 'Programmable legal and technical infrastructure' },
    heroText: {
      es: 'Construimos contratos inteligentes alineados con el producto, el modelo operativo y la necesidad de trazabilidad del proyecto.',
      en: 'We build smart contracts aligned with the product, the operating model and the traceability needs of the project.'
    },
    bullets: {
      es: [
        'Roles, permisos y flujos automatizados.',
        'Base para marketplaces, emisión o validación.',
        'Integración con frontends y procesos institucionales.'
      ],
      en: [
        'Roles, permissions and automated flows.',
        'Base layer for issuance, marketplaces or validation.',
        'Integration with frontends and institutional processes.'
      ]
    },
    image: 'https://images.unsplash.com/photo-1639322537228-f710d846310a?auto=format&fit=crop&w=1400&q=80',
    email: 'smartcontracts@innovativehorizonseua.com',
    contactName: 'Smart contracts team'
  },
  {
    id: 6,
    slug: 'dao-web3-defi',
    cName: 'fas fa-sitemap',
    title: { es: 'DAO, Web3 y arquitectura digital', en: 'DAO, Web3 and digital architecture' },
    desc: {
      es: 'Acompañamos el diseño de ecosistemas descentralizados con gobernanza, participación, identidad y componentes modulares.',
      en: 'We support the design of decentralized ecosystems with governance, participation, identity and modular components.'
    },
    heroTitle: { es: 'Ecosistemas digitales con visión estratégica', en: 'Digital ecosystems with strategic vision' },
    heroText: {
      es: 'Integramos Web3, gobernanza y modelos de coordinación digital en productos y plataformas listos para crecer.',
      en: 'We integrate Web3, governance and digital coordination models into products and platforms built to scale.'
    },
    bullets: {
      es: [
        'Gobernanza digital y participación.',
        'Arquitectura modular para comunidad y producto.',
        'Diseño técnico y estratégico del ecosistema.'
      ],
      en: [
        'Digital governance and participation.',
        'Modular architecture for community and product.',
        'Strategic and technical ecosystem design.'
      ]
    },
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1400&q=80',
    email: 'web3@innovativehorizonseua.com',
    contactName: 'Web3 team'
  }
];

export const defaultContact = {
  title: 'Innovative Horizons',
  email: 'contacto@innovativehorizonseua.com',
  contactName: 'Innovative Horizons team'
};
